<template>
  <div class="c-dropdown" :class="{'opened' : switcher}">
    <input id="checkout-countries" class="d-none" type="checkbox" v-model="switcher">
    <label
      @mouseover="block(true)" @mouseleave="block(false)"
      for="checkout-countries"
      class="c-dropdown__toggle d-flex align-items-center">
      <p class="mb-0 me-3 d-flex align-items-center">
        <img :src="countryFlag" alt="">
        <span class="w-medium fs-14 ms-2 d-none d-md-block">{{countryLabel}}</span>
      </p>
      <Icon icon="bi:caret-down-fill" class="fs-21" />
    </label>
    <div
      class="c-dropdown__body">
      <ul class="ul-reset">
        <li @click="setCountry('pe', 'Perú')" class="c-dropdown__item d-flex align-items-center">
          <img src="../../assets/images/icons/countries/pe.svg" alt="">
          <span class="ms-2">Peru</span>
        </li>
        <li
          @click="setCountry('world', 'Otro país')"
          class="c-dropdown__item d-flex align-items-center">
          <img src="../../assets/images/icons/countries/world.svg" alt="">
          <span class="ms-2">Otro país</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Icon } from '@iconify/vue2';
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      switcher: false,
      isOpened: false,
    }
  },
  components: {
    Icon,
  },
  watch: {
    'switcher': function() {
      document.onclick = () => {
        this.unblock();
      }
    },
  },
  computed: {
    ...mapState({
      country: (state) => state.checkout.country,
    }),

    'countryFlag': function(){
      const country = ( ['pe'].includes(this.country.code) ) ? this.country.code : 'world';

      return `${window.arcux.site}/app/themes/arcuxt/dist/images/icons/countries/${country}.svg`;
    },
    'countryLabel': function(){
      switch (this.country.code) {
        case 'pe':
          return 'Perú';
          break;

        default:
          return 'Otro país';
          break;
      }
    },
  },
  methods: {
    ...mapActions(['updateCountry']),

    block: function(state) {
      if (state) {
        this.isOpened = true;
      } else {
        this.isOpened = false;
      }
    },
    unblock: function() {
      if(!this.isOpened) {
        this.switcher = false;
      }
    },
    setCountry: function(code, label) {
      this.updateCountry({
        ...this.country,

        code: code,
        label: label,
      });
    },
  },
}
</script>
